export default __webpack_public_path__ + "static/media/kinitics-automation.8fbf4ebe.webp";